import { useEffect } from 'react';
import { useAppDispatch, useAppState } from '@/store';
import { getBaseTemplates, selectLLMTemplates, selectLLMTemplatesIsLoading } from '../feature';

export const useGetLLMTemplates = () => {
  const isLoading = useAppState(selectLLMTemplatesIsLoading);
  const templates = useAppState(selectLLMTemplates);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getBaseTemplates());
  }, [dispatch]);

  return {
    isLoading,
    templates,
  };
};
